import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { breakpoints } from "../styles/Variables";
import ContactButton from "../components/ContactButton";
import { BsArrowsFullscreen } from "react-icons/bs";
import AnimatedBackground from "../components/AnimatedBackground";

// left: calc(4rem + 7.75vh + 4rem);

const IndexPageStyles = styled.div`
  position: relative;
  height: 100%;

  .intro {
    position: relative;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
      display: flex;
      justify-content: space-between;
      min-width: 800px;
      width: 70vw;
      max-width: 1000px;

      .tiny {
        display: inline-block;
        margin-bottom: 0.5rem;
      }

      @media (max-width: ${breakpoints.breakHome}) {
        transform: none;
        position: initial;
        flex-direction: column;
        width: 100%;
        justify-content: center;
        padding: 33vh 2rem 0 2rem;
        min-width: unset;

        --fsTitle2: 1rem;

        h1 {
          font-size: 1.2rem;
          line-height: 1.3rem;
        }
      }

      @keyframes braceEntrance {
        from {
          transform: scaleY(1.5);
          opacity: 0;
        }
        to {
          transform: scaleY(1);
          opacity: 0.3;
        }
      }

      .decorativeBrace {
        font-size: 320px;
        margin-top: -45px;
        opacity: 0.3;
        cursor: default;
        animation: braceEntrance 2s ease backwards;
        transition: transform 1.25s;

        &:hover {
          transform: scaleY(1.2);
        }

        @media (max-width: ${breakpoints.breakHome}) {
          animation: none;
          transform: rotate(90deg);
          position: absolute;
          left: calc(50% - 20px);
          top: 10vh;
          font-size: 200px;
        }
      }

      .textWrapper {
        max-width: 28em;

        @media (max-width: ${breakpoints.breakHome}) {
          .textBlock {
            margin-bottom: 2rem;
          }
        }
      }

      h1 {
        margin-top: 0;
      }

      p {
        margin: 0;
      }

      a {
        letter-spacing: 0.5px;
      }

      .technologies {
        font-weight: normal;
      }

      .tiny {
        margin-left: -0.5em;
      }

      nav {
        font-size: var(--fsTitle2);
        display: flex;
        flex-direction: column;
        justify-content: center;

        .linkElement {
          display: flex;
          align-items: center;
          gap: 4rem;

          @media (max-width: ${breakpoints.breakHome}) {
            gap: 2rem;
          }

          &:hover {
            .linkArrow {
              transform: translateX(2rem);
            }
          }
        }

        a,
        button {
          transform: translateY(-5px);
          transition: all 1s;

          &:hover {
            transform: scaleX(1.5);
            border-bottom: 1px solid var(--white);
            border-top-color: transparent;
          }
        }

        .linkArrow {
          font-size: 4rem;
          opacity: 0.6;
          transition: transform 0.75s;

          @media (max-width: ${breakpoints.breakHome}) {
            font-size: 2rem;
          }
        }
      }

      // Small screens
      @media (max-width: ${breakpoints.breakSm}) {
      }
    }
  }
`;
const IndexPage = () => {
  return (
    <IndexPageStyles>
      <AnimatedBackground />
      <section className="intro">
        <div className="content">
          <span class="decorativeBrace">&#123;</span>
          <div className="textWrapper">
            <div className="textBlock">
              <span className="tiny">we do</span>
              <h1>Full stack web development</h1>
              <h1>API development</h1>
              <h1>Code reviews</h1>
            </div>

            <div className="textBlock">
              <span className="tiny">with</span>
              <h2 className="technologies">
                SvelteKit, AWS, Anthropic API, React, Next.js, WordPress,
                KeyStoneJS, Shopify, SquareSpace
              </h2>
            </div>
          </div>
          <nav>
            <div class="linkElement">
              <span class="linkArrow">→</span>
              <Link to="/work">work</Link>
            </div>
            <div class="linkElement">
              <span class="linkArrow">→</span>
              <ContactButton />
            </div>
          </nav>
        </div>
      </section>

      <section className="work">{/* TODO: grab posts here */}</section>
    </IndexPageStyles>
  );
};

export default IndexPage;
